<template>
  <div>
    <!-- <detailsInternalRequest
      ref="details"
      v-bind="bindDetail"
    ></detailsInternalRequest> -->
    <el-row
      type="flex"
      justify="end"
      style="padding-bottom: 0px; margin-bottom: 0px"
    >
      <el-col :span="12">
        <rabbey-toolbox
          filter-placeholder="Buscar por numero de ticket"
          filterables
          @filter-search="handleSearch"
        >
        </rabbey-toolbox>
      </el-col>
    </el-row>
    <el-row>
      <el-col>
        <rabbey-table-3
          :border="true"
          :stripe="true"
          :loading="loading"
          :data="report"
          :columns="mapColumns"
        />
      </el-col>
    </el-row>
    <!-- <rabbey-base-drawer :title="title" :drawer.sync="drawer" size="85%" :before-close="CloseDetails">
      <el-row>
        <div>
          <DetailChart ref="detailChart" :DetailParams="DetailParams" />
        </div>
        <el-col>
          <rabbey-table-3 :border="true" :stripe="true" :loading="loadingDetail" :data="requests"
            :columns="columnsDetails" />
        </el-col>
      </el-row>
    </rabbey-base-drawer> -->
  </div>
</template>

<script>
// import ImagePersonVue from "@/components/functionals/ImagePerson.vue";
// import HyperLinkNewProspectsKPI from "@/components/functionals/HyperLinkNewProspectsKPI.vue";
// import { MONTHS_LIST } from "@/const";
// import DetailChart from "@/views/Charts/NewProspectsReportChart.vue";
// import DatetimeFormatter from "@/components/functionals/DatetimeFormatter.vue";
// import SellerSelector from "@/components/Company/SellerSelectorCodeString.vue";
// import ColorDealClasification from "@/components/functionals/ColorDealClasification.vue";
import DatetimeFormatter from "@/components/functionals/DatetimeFormatter.vue";
export default {
  name: "TicketSearch",
  components: {},
  created() {
    this.fetchReport();
  },
  data() {
    return {
      loading: false,
      loadingDetail: false,
      columns: [
        {
          prop: "ticketid",
          label: "Numero",
          minWidth: 200
        },
        {
          prop: "secuencia",
          label: "Lote",
          minWidth: 100
        },
        {
          prop: "status",
          label: "Estado",
          minWidth: 100
        },
        {
          prop: "valor",
          label: "Monto",
          minWidth: 150
        },
        {
          prop: "cliente",
          label: "Cliente",
          minWidth: 300
        },
        {
          prop: "Fecha",
          label: "Fecha",
          minWidth: 150,
          formatter: DatetimeFormatter
        },
        {
          prop: "consumo_fecha",
          label: "Fecha Consumo",
          minWidth: 150,
          formatter: DatetimeFormatter
        },
        {
          prop: "empresa",
          label: "Empresa Emisora",
          minWidth: 300
        },
        {
          prop: "consumo_rnc",
          label: "RNC Consumo",
          minWidth: 200
        },
        {
          prop: "consumo_empresa",
          label: "Empresa Consumo",
          minWidth: 300
        },
        {
          prop: "consumo_usuario",
          label: "Usuario Consumo",
          minWidth: 300
        },
        {
          prop: "consumo_cantidad",
          label: "Cantidad Consumo",
          minWidth: 150
        },
        {
          prop: "orderid",
          label: "Numero de orden",
          minWidth: 150
        },
        {
          prop: "impreso",
          label: "Estado impresion",
          minWidth: 150
        },
        {
          prop: "terminal",
          label: "Terminal Consumo",
          minWidth: 150
        },
        {
          prop: "fecha_vence",
          label: "Fecha Vencimiento",
          minWidth: 150,
          formatter: DatetimeFormatter
        },
        {
          prop: "factura",
          label: "Factura",
          minWidth: 200
        }
      ],
      // columnsDetails: [
      //   {
      //     prop: "ContactCode",
      //     label: "Codigo Prospecto",
      //     minWidth: 150
      //   },
      //   {
      //     prop: "CompanyName",
      //     label: "Empresa",
      //     width: 250
      //   },
      //   {
      //     prop: "ContactAddress",
      //     label: "Direccion",
      //     minWidth: 300
      //   },
      //   {
      //     prop: "City",
      //     label: "Ciudad",
      //     width: 200
      //   },
      //   {
      //     prop: "SellerName",
      //     label: "Vendedor",
      //     formatter: ImagePersonVue,
      //     attrs: {
      //       imgKey: "ImageSeller"
      //     },
      //     minWidth: 220,
      //     sortable: true,
      //     fix: true
      //   },
      //   // {
      //   //   prop: "Currency.Name",
      //   //   label: "Moneda",
      //   //   width: 100
      //   // },
      //   // {
      //   //   prop: "DaysLate",
      //   //   label: "Dias abierta",
      //   //   //formatter: DatetimeFormatter,
      //   //   width: 180
      //   // },
      //   {
      //     prop: "CreatedAt",
      //     label: "Fecha de creacion",
      //     formatter: DatetimeFormatter,
      //     width: 180
      //   },
      //   {
      //     prop: "CreatorName",
      //     label: "Creador",
      //     formatter: ImagePersonVue,
      //     attrs: {
      //       imgKey: "ImageCreator"
      //     },
      //     minWidth: 220,
      //     sortable: true,
      //     fix: true
      //   }
      // ],
      report: [],
      // year: new Date().getFullYear(),
      request_type: null,
      title: "",
      drawer: false,
      // selectedTechnician: "",
      requests: [],
      technicians: [],
      techniciansLoading: false,
      //requestColumns: requestColumns,
      createdOrClosed: true,
      serviceRequestType: null
      // DetailParams: {
      //   Month: 0,
      //   Year: 0,
      //   UserID: 0,
      //   chartData: []
      // }
    };
  },
  computed: {
    // years() {
    //   const lowLevel = 2019;
    //   const currentYear = new Date().getFullYear();
    //   let Years = [];
    //   for (let i = lowLevel; i <= currentYear; i++) {
    //     Years.push({ label: i, value: i });
    //   }
    //   return Years;
    // },
    mapColumns() {
      let columns = this.columns;
      return columns;
    }
  },
  methods: {
    fetchReport(ticketid = null) {
      this.loading = true;
      this.$http
        .get("/api/tennos/GetTicket", {
          params: {
            ticketid
          }
        })
        .then(({ data }) => {
          this.report = data;
          console.log(data);
        })
        .catch((error) => console.error(error))
        .finally(() => (this.loading = false));
    },
    handleSearch(ticketid) {
      this.fetchReport(ticketid);
    }
    // handleChangeSeller() {
    //   this.page = 1;
    //   this.fetchReport();
    // },
    // updateSelectedEmployee(val) {
    //   this.selectedEmployee = val;
    //   this.fetchReport();
    // },
    // updateSelectedDirection(val) {
    //   this.selectedDirection = val;
    //   this.fetchReport();
    // },
    // handlePushAction(option) {
    //   if (option.command == "details") {
    //     this.bindDetail = {
    //       comments: [],
    //       descripcionLaga: option.row.Descripcion,
    //       descripcionCorta: option.row.corta
    //     };

    //     // if (option.row != null && option.row.Activities != null) {
    //     //   const c = option.row.Activities.filter(a => (a.Type = 1));
    //     //   this.bindDetail.comments = JSON.parse(JSON.stringify(c));
    //     // }
    //     this.$refs.details.drawer = true;
    //   }
    // },
    // openSelect(props) {
    //   this.loadingDetail = true;
    //   this.title = `Nuevos prospectos creados por ${props.row.VendorName}`;
    //   this.drawer = true;
    //   this.DetailParams = {
    //     Month: props.month,
    //     Year: this.year,
    //     UserID: props.row.userId
    //   };
    //   this.$http
    //     .get("/api/deals/NewProspectsReportDetails", {
    //       timeout: 3000 * 6 * 1000,
    //       params: {
    //         year: this.year,
    //         UserID: props.row.userId,
    //         month: props.month
    //       }
    //     })
    //     .then(({ data }) => {
    //       this.requests = data;
    //       // this.DetailData.chartData = data.serviceChart;
    //       this.$refs.detailChart.getChartData();
    //     })
    //     .finally(() => (this.loadingDetail = false));
    // },
    // CloseDetails() {
    //   this.drawer = false;
    //   this.$refs.detailChart.bar.series[0].data = [];
    //   this.$refs.detailChart.loading = true;
    // },
    // getSummaries(param) {
    //   const { columns, data } = param;
    //   var sums = [];
    //   columns.forEach((column, index) => {
    //     if (index === 0) {
    //       sums[index] = "";
    //       return;
    //     }
    //     const values = data.map(item => Number(item[column.property]));
    //     if (!values.every(value => isNaN(value))) {
    //       sums[index] = values.reduce((prev, curr) => {
    //         const value = Number(curr);
    //         if (!isNaN(value)) {
    //           return prev + curr;
    //         } else {
    //           return prev;
    //         }
    //       }, 0);
    //     } else {
    //       sums[index] = "Totales :";
    //     }
    //   });
    //   return sums;
    // }
  }
};
</script>
